import React from "react";
import { createRoot } from "react-dom/client"; 
import "./index.css";
import App from "./App";
//npx update-browserslist-db@latestimport reportWebVitals from "./reportWebVitals";

const root = createRoot(document.getElementById("root"));
root.render(<App />);